export default __webpack_public_path__ + "static/media/on-success-icon.4e384b53.svg";